<h3>{{ "My Courses" | translate }}</h3>

<div class="row g-4">
  <div class="col-12 col-md-4" *ngFor="let course of courses">
    <div class="course-card">
      <div class="card-img">
        <img [src]="course.imageIconPath" [alt]="course.imageAlt" />
      </div>
      <div class="card-content">
        <h1>{{ course.titleTr }}</h1>
        <p class="mb-4">{{ course.summary }}</p>
        <a class="btn" (click)="getDetailsUrl(course)">{{ course.btnText }}</a>
      </div>
    </div>
  </div>
</div>